<template>
  <footer class="footer">
    <div class="container pull-right">
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }} - LiftX Consult
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
